<template>
    <div class="authorCenter">
        <Header></Header>
        <div class="authorBox flexible authorBox-big">
            <sidebar></sidebar>
            <div class="writewrap flex">
                <!-- <Bread></Bread> -->
                <div class="right author-right">
                    <div class="chapter-title flexible aItem-center jc-between">
                        <div class="page-title font-MT ">
                            <!-- <img class="fh-img" src="@/assets/ic_fh.png" alt="" @click="goBack()"> -->
                            <span class="f22 page-name text-333 fwb-600">我的消息</span>
                        </div>


                    </div>
                    <!-- <div class="chapter-title flexible aItem-cenmessageListter">
                        <span v-for="(message, index) in messageList" :class="tabIndex == message.type?'active-tab':''"
                            class="f-csp font-MT f16" @click="tabIndex = message.type">
                            {{message.name}}
                            <i class="line" v-if="tabIndex == message.type"></i>
                        </span>
                    </div> -->
                    <div class="messageList">
                        <div class="msgItem" v-for="msg in messagelist">
                            <!-- <div class="title-icon">
                                <img src="../../assets/message/icon1.png" />
                            </div> -->
                            <div class="msg-con font-MT">
                                <div class="msg-con-top text-muted">
                                    <span class="f16 text-333">{{msg.title ? msg.title:''}}</span>
                                    <span class="msg-con-time f14 text-999">{{msg.createTime}}</span>
                                </div>
                                <div class="msg-con-detail mt20 text-333 f16 mb40" v-html="msg.content">
                                </div>
                                <div class="msg-line"></div>
                            </div>
                        </div>
                    </div>
                    <div class="datanull" v-if="messagelist.length == 0">
                        <img src="@/assets/author/no-data.png" />
                        <p>暂无消息</p>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import {
        // AuthorNotice,
        getMoticeApi,
        // noticed
    } from 'apiurl/notice';
    export default {
        data() {
            return {
                messageList: [
                    {
                        name: '今日消息',
                        type: 1,
                    },
                    {
                        name: '以往消息',
                        type: 2,
                    },
                ],
                tabIndex: 1,
                params: {
                    pageNo: 1,
                    pageSize: 10,
                    // sort: 1
                },
                messagelist: [],
                busy: false,
            };
        },
        mounted() {
            window.addEventListener('scroll', this.getbottom); // 滚动到底部，再加载的处理事件
            this.getAuthorNotice()
            // this.getnoticed()
        },
        methods: {
            async getAuthorNotice() {
                let msg = await getMoticeApi(this.params)
                if (msg) {
                    if (msg.success) {
                        if (msg.data.items.length > 0) {
                            this.messagelist = this.messagelist.concat(msg.data.items);
                            this.busy = msg.data.hasNextPage
                            this.params.pageNo = Number(msg.data.pageNum)
                        }
                    }
                }
            },
            getbottom() {
                let scrollTop =
                    document.documentElement.scrollTop || document.body.scrollTop;
                let clientHeight =
                    document.documentElement.clientHeight || document.body.clientHeight;
                let scrollHeight =
                    document.documentElement.scrollHeight || document.body.scrollHeight;
                let numHeight = scrollTop + clientHeight;
                if (scrollHeight > clientHeight && numHeight > scrollHeight - 100) {
                    if (this.busy) {
                        this.busy = false;
                        this.params.pageNo++;
                        this.getAuthorNotice()
                    }
                }
            }
        },
        // 销毁事件
        destroyed() {
            window.removeEventListener('scroll', this.getbottom, false)
        }
    };
</script>

<style lang="scss" scoped>
    @import "@/styles/author.scss";

    // .chapter-title {
    //     height: 90px;
    //     box-shadow: 0px 0px 10px rgba(0, 0, 0, 0.1);
    //     border-radius: 16px 16px 0 0;

    //     span {
    //         display: inline-block;
    //         height: 90px;
    //         line-height: 90px;
    //         margin-right: 30px;
    //         position: relative;

    //         i {
    //             display: block;
    //             width: 50px;
    //             height: 6px;
    //             background: #000;
    //             position: absolute;
    //             border-radius: 3px;
    //             bottom: 0;
    //             left: 50%;
    //             transform: translateX(-50%);
    //         }
    //     }

    //     span:first-child {
    //         margin-left: 51px;
    //     }
    // }

    .messageList {
        width: 100%;
        padding-bottom: 50px;

        .msgItem {
            // margin: 40px 50px 0 50px;
            // border-bottom: 1px solid #DEDEDE;

            .title-icon {
                width: 40px;
                height: 40px;

                img {
                    width: 40px;
                    height: 40px;
                }
            }

            .msg-con {
                margin: 37px 0 20px;

                .msg-con-time {
                    margin-left: 60px;
                }

                .msg-con-detail {
                    padding: 20px;
                    background: #FBFBFB;
                    border-radius: 4px;

                    /deep/a {
                        color: #F68A01 !important;
                    }
                }
                .msg-line{
                    height: 1px;
                    background: #F2F2F2;
                    width:960px;
                }


            }
        }
    }

    .aItem-cenmessageListter {
        border-bottom: 1px solid #F2F2F2;
        // padding:10px 0;
        margin-top: 40px;

        span {
            color: #999;
            margin-right: 60px;
            padding-bottom: 10px;
        }

        .active-tab {
            color: #333 !important;
            border-bottom: 4px solid #333;
        }
    }
</style>